// AuthLayout.jsx
import {Divider} from 'antd';
import {useState} from 'react';

import BgImg2 from '../../Assets/AuthBg.jpg';
import logo from '../../Assets/Logo3.png';
import {LoginScreen} from '../AuthLayout/LoginScreen';

const AuthLayout = () => {

  return (
    <div className={'min-h-screen flex items-center md:p-0 p-8 justify-center bg-primary-50'}>
      <div 
        style={{
          backgroundImage: `url(${BgImg2})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
        className={'w-full  max-w-5xl md:h-[500px] h-[550px]  bg-white rounded-2xl shadow-lg flex md:flex-row flex-col overflow-hidden'}>
        
        {/* LEFT IMAGE */}
        <div className={'md:w-1/2 md:mt-0 mt-8 flex flex-col justify-center text-center items-center w-full'}>
          <h1 className={'md:text-4xl text-2xl font-sans font-extrabold md:mb-7 mb-4 text-primary-900'}>WELCOME</h1>
          <h1 className={'md:text-4xl text-2xl font-sans font-extrabold md:mb-1 text-primary-900'}>TO</h1>
          <img
            src={logo}
            alt={'clothing'}
            className={'object-cover md:h-40 h-20'}
          />
        </div>

        <div className={'w-full md:w-1/2 md:m-8 md:shadow-xl md:rounded-xl md:border md:border-primary-100 flex items-center justify-center'}>
          <div className={'w-full text-center justify-center max-w-sm'}>
            
            <LoginScreen />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
